module.exports = __webpack_public_path__ + "static/media/mental-health@2x.79def68c.png";